import * as ALL_MODES from "redux/tools/enums";

export const LABEL_SOURCE_STATUSES = Object.freeze({
  NEW: "new",
  ASSIGNED: "assigned",
  IN_REVIEW: "in_review",
  IN_ADMIN_REVIEW: "in_admin_review",
  SUBMITTED: "submitted",
  APPROVED: "approved",
  DOUBLE_CHECKED: "doublecheck",
  REOPENED: "reopen",
  REOPENED_REVIEWER: "reopened_reviewer",
  SKIPPED: "skipped",

  /**@deprecated */
  DECLINED: "declined",
  /**@deprecated */
  INPROGRESS: "inprogress",
});

export const USER_ROLES = Object.freeze({
  LABELER: "project_labeler",
  REVIEWER: "project_reviewer",
  PROJECT_MANAGER: "project_manager",
  ADMIN: "admin",
});

export const USER_ROLE_LABELS = {
  [USER_ROLES.LABELER]: "Labler",
  [USER_ROLES.REVIEWER]: "Reviewer",
  [USER_ROLES.PROJECT_MANAGER]: "PM",
  [USER_ROLES.ADMIN]: "Admin",
};

export const USER_ROLE_POSITION = {
  [USER_ROLES.LABELER]: 1,
  [USER_ROLES.REVIEWER]: 2,
  [USER_ROLES.PROJECT_MANAGER]: 3,
  [USER_ROLES.ADMIN]: 4,
};

export const dropdownItemsByStatus = [
  {
    value: LABEL_SOURCE_STATUSES.ASSIGNED,
    name: "common.assigned",
    filterStatuses: [LABEL_SOURCE_STATUSES.ASSIGNED],
  },
  {
    value: LABEL_SOURCE_STATUSES.SUBMITTED,
    name: "common.submitted",
    filterStatuses: [LABEL_SOURCE_STATUSES.SUBMITTED],
  },
  {
    value: LABEL_SOURCE_STATUSES.REOPENED,
    name: "common.reopen",
    filterStatuses: [LABEL_SOURCE_STATUSES.REOPENED],
  },
  {
    value: LABEL_SOURCE_STATUSES.APPROVED,
    name: "common.approved",
    filterStatuses: [LABEL_SOURCE_STATUSES.APPROVED],
  },
  {
    value: LABEL_SOURCE_STATUSES.REOPENED_REVIEWER,
    name: "common.reopened_reviewer",
    filterStatuses: [LABEL_SOURCE_STATUSES.REOPENED_REVIEWER],
  },
  {
    value: LABEL_SOURCE_STATUSES.DOUBLE_CHECKED,
    name: "common.doublecheck",
    filterStatuses: [LABEL_SOURCE_STATUSES.DOUBLE_CHECKED],
  },
  {
    value: LABEL_SOURCE_STATUSES.SKIPPED,
    name: "common.skipped",
    filterStatuses: [LABEL_SOURCE_STATUSES.SKIPPED],
  },
  {
    value: LABEL_SOURCE_STATUSES.NEW,
    name: "common.unassigned",
    filterStatuses: [LABEL_SOURCE_STATUSES.NEW],
  },
];

export const CLASS_TYPE_CODES = {
  BOX_IMAGE: "box-image",
  POLYGON_IMAGE: "polygon-image",
  OCR_IMAGE: "ocr-image",
  SEGMENTATION_IMAGE: "segmentation-image",

  /**@deprecated */
  BOX_VIDEO: "box-video",
  /**@deprecated */
  CUBOID_IMAGE: "cuboid-image",
  /**@deprecated */
  POINT_IMAGE: "point-image",
  /**@deprecated */
  POLYLINE_IMAGE: "polyline-image",
  /**@deprecated */
  SPEAKER_VIDEO: "speaker-video",
  /**@deprecated */
  TEMPORAL_VIDEO: "temporal-video",
};

export const CLASS_TYPE_CODE_MAP_MODE_TOOL = {
  [CLASS_TYPE_CODES.BOX_IMAGE]: ALL_MODES.BOX_MODE,
  [CLASS_TYPE_CODES.POLYGON_IMAGE]: ALL_MODES.POLYGON_MODE,
  [CLASS_TYPE_CODES.POLYLINE_IMAGE]: ALL_MODES.POLYLINE_MODE,
};
